import { Component, OnInit } from '@angular/core';
import { IArticle } from 'src/app/core/interfaces/article';
import {
  first
} from 'rxjs/operators';
import { Router } from '@angular/router';
import { ArticleService } from 'src/app/core/services/article.service';
@Component({
  selector: 'app-home-actus',
  templateUrl: './home-actus.component.html',
  styleUrls: ['./home-actus.component.scss']
})
export class HomeActusComponent implements OnInit {
  articlesList: IArticle[] = [];
  filterLastArticle: any = {};

  constructor(private articleService: ArticleService,) {}

  ngOnInit(): void {
    this.fetchLastArticles(3)
  }

  fetchLastArticles(limit : number) {
    this.filterLastArticle.limit = limit
    this.filterLastArticle.image = true
    this.filterLastArticle.affhome = true
    this.articleService.fetLactArticles(this.filterLastArticle).pipe(first()).subscribe(response => {
      this.articlesList = response.data;
    });
  };
}
